import Storefront from "../types/Storefront";

export const useStorefront = (): Storefront => {
	if (typeof window._esfn === "undefined") {
		throw new Error("Current state not available on window._esfn");
	}

	return window._esfn;
};
